// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"842":"5255a18a","869":"95ba466e"}[chunkId] + ".chunk.js";
};